angular.module('common.directives.omSpinner', [])

    // OrderManager loading spinner directive
    .directive('omSpinner', function () {
        return {
            restrict: 'AEC',
            templateUrl: 'common/directives/omSpinner/omSpinner.html',
            scope: {
                size: '@',
                type: '@'
            },
            controller: 'OmSpinnerController'
        };
    })

    .controller('OmSpinnerController', function ($scope, $element, $window, $interval, customResourceResolver) {

        getSpinnerConfig();

        function getSpinnerConfig() {
            return customResourceResolver.resolveConfig("spinner-config", null)
                .then(function(spinnerConfig) {
                    if(spinnerConfig) {
                        $scope.type = spinnerConfig.type;
                    }
                });
        }
    })
;
